/**
 * Motivos pelos quais a Secretaria libera a trava da sentença antes do fim do prazo. Espelha o
 * enum fechado `MOTIVOS_LIBERACAO_SENTENCA` do core: um motivo fora dele o POST recusa com 400.
 */
export type MotivoLiberacaoSentenca = 'DESISTENCIA' | 'EXTINCAO' | 'CONTESTACAO_NEGA_DIVIDA';

/** Ordem em que o diálogo da Secretaria oferece os motivos. */
export const MOTIVOS_LIBERACAO_SENTENCA = [
  'DESISTENCIA',
  'EXTINCAO',
  'CONTESTACAO_NEGA_DIVIDA',
] as const satisfies readonly MotivoLiberacaoSentenca[];

/**
 * Rótulo de cada motivo. Fonte única para o diálogo da Secretaria (onde o motivo é escolhido) e o
 * editor de sentença do árbitro (onde a liberação aparece, D-06): os dois têm de falar do mesmo
 * motivo com o mesmo nome.
 */
export const MOTIVO_LIBERACAO_LABEL: Record<MotivoLiberacaoSentenca, string> = {
  DESISTENCIA: 'Pedido de desistência',
  EXTINCAO: 'Pedido de extinção',
  CONTESTACAO_NEGA_DIVIDA: 'Contestação que nega a dívida',
};

/**
 * Estreita um valor vindo do Select ou do painel do árbitro para um motivo conhecido. `false` para
 * vazio e para um motivo que o core venha a criar antes deste front: o chamador omite o rótulo em
 * vez de mostrar o enum cru.
 *
 * @example ehMotivoLiberacao('EXTINCAO') // true
 * @example ehMotivoLiberacao(null) // false
 */
export function ehMotivoLiberacao(
  valor: string | null | undefined,
): valor is MotivoLiberacaoSentenca {
  return MOTIVOS_LIBERACAO_SENTENCA.some((motivo) => motivo === valor);
}
